import { render, staticRenderFns } from "./cargoUserSelect.vue?vue&type=template&id=b16f9f3c&"
import script from "./cargoUserSelect.vue?vue&type=script&lang=js&"
export * from "./cargoUserSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b16f9f3c')) {
      api.createRecord('b16f9f3c', component.options)
    } else {
      api.reload('b16f9f3c', component.options)
    }
    module.hot.accept("./cargoUserSelect.vue?vue&type=template&id=b16f9f3c&", function () {
      api.rerender('b16f9f3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/cargoUserSelect.vue"
export default component.exports